// src/hooks/useLocations.js
import { useState, useEffect, useCallback } from "react";
import {
  collection, onSnapshot, addDoc, updateDoc, doc, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

function locationsCol(orgId) {
  return collection(db, "organizations", orgId, "locations");
}

export function useLocations(orgId) {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId) return;
    setLoading(true);
    return onSnapshot(
      locationsCol(orgId),
      (snap) => {
        const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        all.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        setLocations(all.filter((l) => l.active !== false));
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [orgId]);

  const addLocation = useCallback(async ({ name, address = "" }) => {
    await addDoc(locationsCol(orgId), {
      name: name.trim(),
      address: address.trim(),
      active: true,
      createdAt: serverTimestamp(),
    });
  }, [orgId]);

  const updateLocation = useCallback(async (locationId, fields) => {
    await updateDoc(doc(db, "organizations", orgId, "locations", locationId), fields);
  }, [orgId]);

  const deactivateLocation = useCallback(async (locationId) => {
    await updateDoc(doc(db, "organizations", orgId, "locations", locationId), { active: false });
  }, [orgId]);

  return { locations, loading, addLocation, updateLocation, deactivateLocation };
}
